import React from "react";
import { Skeleton } from "antd";
import styles from "./Blank.module.scss";
export function BlankV2() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.blankV2
  }, /*#__PURE__*/React.createElement(Skeleton.Button, {
    size: "small",
    block: true
  }));
}